import './styles.sass'
import { ReactNode } from 'react'
import cx from 'classnames'
import { Icon } from '../Icon'

interface TooltipProps {
	children: ReactNode
	className?: string
}

const Tooltip = ({ children, className }: TooltipProps) => {
	const cs = cx('tooltip', className)

	return (
		<div className={cs}>
			<Icon name='info' width={20} fill='#84879A' />
			<span className='tooltiptext'>{children}</span>
		</div>
	)
}

export default Tooltip
